export const GET_INVESTMENT_TABDATA = "GET_INVESTMENT_TABDATA";
export const CREATE_INVESTMENT_DATA = "CREATE_INVESTMENT_DATA";
export const SIDE_MENU_TOGGLE = "SIDE_MENU_TOGGLE";
